import { render, staticRenderFns } from "./ForDumpList.vue?vue&type=template&id=074e94c2"
import script from "./ForDumpList.vue?vue&type=script&lang=js"
export * from "./ForDumpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports